import React from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {UseWindowSize} from '../../features/hooks/UseWindowSize'
import {useHistory} from 'react-router-dom'

type PropsWindowSize = {
    innerWidth: number,
}

const BackButton: React.FC = () => {
    const {width} = UseWindowSize()
    const history_ = useHistory()

    const handleBack = () => {

        //const lastEntry = getLastEntry()

        // if (lastEntry) {
        //   console.log('Restoring state for:', lastEntry.url)
        //   console.log('Restored state:', lastEntry.state)
        //   removeLastEntry();
        // }
        history_.goBack()
    }

    return (
        <>
            <button className="btn btn-sm btn-flex btn-light btn-active-primary fw-bolder"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                    data-kt-menu-flip="top-end"
                    onClick={handleBack}
            >
                <KTSVG path="/media/icons/duotune/arrows/arr002.svg"
                       className={`svg-icon-3 svg-icon-primary ${(width >= 576) ? 'me-2' : ''}`}
                />
                {(width >= 576) ? 'Retour' : ''}
            </button>
        </>
    )
}

export {BackButton}
